import React from 'react'
import { getTranslateByKey } from '@/main/services/utils';
import { integrationInterfaceCompanyApi } from '@/main/api';
import { IntegrationInterfaceCompanyResponse } from '@/main/models/response';
import { IntegrationInterfaceCompanyRequest } from '@/main/models/request';
import KOGPaginationGrid from '@/main/components/shared/paginationGrid/paginationGrid';
import BoxGrid from '@/main/components/shared/boxGrid/boxGrid';
import RowDataIntegrationCompany from './rowDataIntegrationCompany/rowDataIntegrationCompany';
import * as S from './styles';

interface IGridSearchIntegrationProps {
  dataGrid: IntegrationInterfaceCompanyResponse[];
  formFilters: IntegrationInterfaceCompanyRequest | null;
  setDataGrid: React.Dispatch<React.SetStateAction<IntegrationInterfaceCompanyResponse[]>>;
}

function GridSearchIntegration({
  dataGrid,
  formFilters,
  setDataGrid
}: IGridSearchIntegrationProps) {
  const rowsHeader = [
    getTranslateByKey('information.companyType'),
    getTranslateByKey('information.company'),
    getTranslateByKey('information.service'),
    getTranslateByKey('information.interface'),
    getTranslateByKey('information.endpoint'),
    <S.TextCenter>{getTranslateByKey('information.status')}</S.TextCenter>
  ]
  async function fetchDataIntegrationQueue(request: any) {
    return integrationInterfaceCompanyApi.getSearchGrid(request).then(response => response.data);
  }

  if (dataGrid.length === 0 && formFilters === null) return null

  return (
    <S.Container>
      <KOGPaginationGrid
        showTitleResults
        dataGrid={dataGrid}
        formFilters={formFilters}
        setDataGrid={setDataGrid}
        fetchMore={fetchDataIntegrationQueue}
        fetchEqualFilters
      >
        <BoxGrid rowHeaders={rowsHeader}>
          {dataGrid.map((item) =>
            <RowDataIntegrationCompany
              key={item.guid}
              integrationInterfaceCompany={item}
            />
          )}
        </BoxGrid>
      </KOGPaginationGrid>
    </S.Container>
  )
}

export default GridSearchIntegration